import type { RootState } from 'Store/index';
import {
	Feature,
	getFeatureAvailableFromState,
	getSoftDeployAccessFromState
} from 'App/components/hooks/featureHelper';

type AccountSelf = RootState['App']['accountSelf'];

/**
 * The AI licence (WEB-6595): the `aiAssistant` feature, which only the Upsales AI licence tier
 * grants, or the `AI_ASSISTANT` soft-deploy flag as the internal escape hatch.
 *
 * Pure functions of `accountSelf`, so there is one statement of each rule (WEB-13133): the routes'
 * hooks feed them from `useSelector` and re-render when the account changes, and the admin sidebar,
 * a class component that cannot call a hook, feeds them the account it reads synchronously.
 */
export const hasAiWorkspaceLicence = (accountSelf: AccountSelf) =>
	getFeatureAvailableFromState(accountSelf, Feature.AI_ASSISTANT) ||
	getSoftDeployAccessFromState(accountSelf, 'AI_ASSISTANT');

/** The V2 prospecting workspace: the AI licence and `PROSPECTING_AGENT_V2` (WEB-10482). */
export const hasProspectingWorkspaceAccess = (accountSelf: AccountSelf) =>
	hasAiWorkspaceLicence(accountSelf) && getSoftDeployAccessFromState(accountSelf, 'PROSPECTING_AGENT_V2');
